import Stack from 'react-bootstrap/Stack'

import { Spinner } from '../LoadingContainer/Spinner'

import './savingOverlay.scss'

const normalizeProgressPercent = (percent) => {
  if (percent === null || percent === undefined || percent === '') return null
  const value = Number(percent)
  if (!Number.isFinite(value)) return null
  return Math.min(100, Math.max(0, Math.round(value)))
}

/**
 * Reusable overlay for long-running save (and similar) operations.
 *
 * Presentation only: callers own request lifecycle, success, and error handling.
 */
export default function SavingOverlay({
  active = false,
  title = 'Saving...',
  message,
  percent = null,
  variant = 'seatmap',
  className = '',
}) {
  if (!active) return null

  const normalizedPercent = normalizeProgressPercent(percent)
  const isDeterminate = normalizedPercent !== null
  const statusMessage = message || title
  const rootClass = ['saving-overlay', `saving-overlay--${variant}`, className]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={rootClass}
      role="status"
      aria-busy="true"
      aria-live="polite"
      aria-label={title}
      data-testid="saving-overlay"
    >
      <div className="saving-overlay__content">
        <span aria-hidden="true">
          <Spinner variant="primary" size="xl" />
        </span>
        <Stack direction="vertical" gap={1} className="align-items-center">
          <h4 className="saving-overlay__title mb-0">{title}</h4>
          {message && (
            <p
              className="saving-overlay__message mb-0"
              data-testid="saving-overlay-message"
            >
              {message}
            </p>
          )}
        </Stack>
        <div
          className="saving-overlay__track"
          role="progressbar"
          aria-label={title}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={isDeterminate ? normalizedPercent : undefined}
          aria-valuetext={
            isDeterminate ? `${normalizedPercent}% complete` : statusMessage
          }
          data-testid="saving-overlay-progress"
          data-mode={isDeterminate ? 'determinate' : 'indeterminate'}
        >
          <div
            className={
              isDeterminate
                ? 'saving-overlay__fill saving-overlay__fill--determinate'
                : 'saving-overlay__fill saving-overlay__fill--indeterminate'
            }
            style={
              isDeterminate ? { width: `${normalizedPercent}%` } : undefined
            }
          />
        </div>
      </div>
    </div>
  )
}
